export default __webpack_public_path__ + "static/media/JP.edaa5c04.ico";